/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-dynamic-delete */
/* eslint-disable react/no-array-index-key */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import { useState, useContext, useRef } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { CircleX, SlidersHorizontal } from "lucide-react";
import { Link } from "react-router-dom";
import {
  Badge,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  Combobox,
  DatePicker,
  Input,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle
} from "@repo/ui";
import { UserContext } from "utils/reducers/user";
import { isOperationAllowed } from "utils/helper";
import Layout from "components/layout";
import {
  useGetCashCenters,
  useGetCustomers,
  useGetRegions
} from "utils/apis/lookups.api";
import { useGetB2BOrders } from "utils/apis/b2b.api";
import { formatDate } from "date-fns";
import { Permissions } from "utils/enums";
import { saveFilters } from "utils/actions/user";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { useGetVansInsuranceLimits } from "utils/apis/daily-operations";
import { RequestDetails } from "./request-details";

const pageSize = 25;
const initialDataState = {};
const routeStatusList = [
  {
    value: "Dispatched",
    label: "Dispatched"
  },
  {
    value: "In Queue",
    label: "In Queue"
  }
];
const limitStatusList = [
  {
    value: "Within Limit",
    label: "Within Limit"
  },
  {
    value: "About to Breach",
    label: "About to Breach"
  },
  {
    value: "Breached",
    label: "Breached"
  }
];

export default function VehicleInsuranceLimitList() {
  const user = useContext(UserContext);
  const [currentRoute, setCurrentRoute] = useState<any>(null);
  const [dataState, setDataState] = useState<any>(initialDataState);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState<any>(
    user?.filters?.["vehicle-insurance-limits"] || {}
  );
  const { data: cashCenters } = useGetCashCenters();
  const { data: regions } = useGetRegions("UAE");
  const {
    isSuccess: requestSuccess,
    data: requestsData,
    isPending: loadingRequests
  } = useGetVansInsuranceLimits({
    pageNumber: currentPage || 1,
    pageRowCount: pageSize,
    searchCriteria:
      filters?.searchCriteria?.id.length >= 3
        ? filters?.searchCriteria?.id
        : "",
    operationDate: formatDate(
      filters?.operationDate?.id || new Date(),
      "yyyy-MM-dd'T'00:00:00.000'Z'"
    ),
    cashCenterId: filters?.cashCenterId?.id || user.CashCenterId,
    region: filters?.region?.id || "",
    routeStatus: filters?.routeStatus?.id || "",
    limitStatus: filters?.limitStatus?.id || ""
  });

  const handleClearFilter = (key: string) => {
    const updatedFilter = { ...filters };
    delete updatedFilter[key];
    setFilters({ ...updatedFilter });
    saveFilters(user.dispatch, {
      ...user.filters,
      "vehicle-insurance-limits": updatedFilter
    });
  };

  const onPageChange = (e: any) => {
    const _currentPage = e.page.skip / e.page.take + 1;
    setCurrentPage(_currentPage);
  };

  const onDataStateChange = (e: any) => {
    setDataState(e.dataState);
  };

  const onOperationDateChanged = (value?: Date) => {
    if (value) {
      setFilters({
        ...filters,
        operationDate: { name: formatDate(value, "PPP"), id: value }
      });
      saveFilters(user.dispatch, {
        ...user.filters,
        "vehicle-insurance-limits": {
          ...filters,
          operationDate: { name: formatDate(value, "PPP"), id: value }
        }
      });
    }
    setCurrentPage(1);
  };

  const onFilterSearch = (e: any) => {
    setCurrentPage(1);
    setFilters({
      ...filters,
      searchCriteria: { name: e.target.value, id: e.target.value }
    });
    saveFilters(user.dispatch, {
      ...user.filters,
      "vehicle-insurance-limits": {
        ...filters,
        searchCriteria: { name: e.target.value, id: e.target.value }
      }
    });
  };

  const handleFiltersUpdate = (key: string, val: any) => {
    const { sourceLocation, onwardLocation, ...remainingFilters } = filters;

    setFilters({
      ...(key === "customer" ? remainingFilters : filters),
      [key]: JSON.parse(val)
    });

    saveFilters(user.dispatch, {
      ...user.filters,
      "vehicle-insurance-limits": {
        ...(key === "customer" ? remainingFilters : filters),
        [key]: JSON.parse(val)
      }
    });
  };

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Vans Insurance Limits</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <Card className="mt-3 mx-4">
        <CardContent>
          <CardDescription className="pt-6">
            <div className="flex mb-3 gap-3">
              <Popover>
                <PopoverTrigger asChild>
                  <Button
                    variant="secondary"
                    className="p-2"
                    title="Apply Filters"
                  >
                    <SlidersHorizontal className="" />
                  </Button>
                </PopoverTrigger>
                <PopoverContent align="start" className="w-[600px]">
                  <h6 className="font-semibold text-lg">Apply Filters</h6>
                  <div className="grid grid-cols-2 gap-4 mt-3">
                    <Combobox
                      placeholder="Select Cash Center"
                      value={JSON.stringify(filters?.cashCenterId) || ""}
                      data={cashCenters?.map((item: any) => ({
                        value: JSON.stringify({
                          name: item.name,
                          id: item.cashCenterId
                        }),
                        label: item.name
                      }))}
                      setValue={(e: any) => {
                        if (e) {
                          setCurrentPage(1);
                          handleFiltersUpdate("cashCenterId", e);
                        } else {
                          handleClearFilter("cashCenterId");
                        }
                      }}
                    />
                    <Combobox
                      placeholder="Select Region"
                      value={JSON.stringify(filters?.region) || ""}
                      data={regions?.map((item: any) => ({
                        value: JSON.stringify({
                          name: item.name,
                          id: item.name
                        }),
                        label: item.name
                      }))}
                      setValue={(e: any) => {
                        if (e) {
                          setCurrentPage(1);
                          handleFiltersUpdate("region", e);
                        } else {
                          handleClearFilter("region");
                        }
                      }}
                    />

                    <Combobox
                      placeholder="Select Route Status"
                      value={JSON.stringify(filters?.routeStatus) || ""}
                      data={routeStatusList.map((item: any) => ({
                        value: JSON.stringify({
                          name: item.label,
                          id: item.value
                        }),
                        label: item.label
                      }))}
                      setValue={(e: any) => {
                        if (e) {
                          setCurrentPage(1);
                          handleFiltersUpdate("routeStatus", e);
                        } else {
                          handleClearFilter("routeStatus");
                        }
                      }}
                    />
                    <Combobox
                      placeholder="Select Limit Status"
                      value={JSON.stringify(filters?.limitStatus) || ""}
                      data={limitStatusList.map((item: any) => ({
                        value: JSON.stringify({
                          name: item.label,
                          id: item.value
                        }),
                        label: item.label
                      }))}
                      setValue={(e: any) => {
                        if (e) {
                          setCurrentPage(1);
                          handleFiltersUpdate("limitStatus", e);
                        } else {
                          handleClearFilter("limitStatus");
                        }
                      }}
                    />
                  </div>
                </PopoverContent>
              </Popover>

              <div className="w-[15%]">
                <DatePicker
                  placeholder="Select Operation Date"
                  selectedDate={filters?.operationDate?.id || new Date()}
                  onSelectDate={onOperationDateChanged}
                />
              </div>

              <Input
                className="w-full mb-2"
                value={filters.searchCriteria?.id}
                onChange={onFilterSearch}
                title="Search: Job No., Job Nature, Status, Route No., Shift"
                placeholder="Search: Job No., Job Nature, Status, Route No., Shift"
              />
              {/* <div className="w-[10%]">
                {loadingRequests ? (
                  <div className="text-end">
                    <Loader size="large" type="pulsing" />
                  </div>
                ) : null}
              </div> */}
            </div>

            <div className="flex gap-2 flex-wrap mb-3 items-center">
              {Object.entries(filters).map(([key, val]: any, i) =>
                val.id ? (
                  <Badge
                    variant="secondary"
                    className="gap-3 pr-1 cursor-pointer"
                    key={i}
                  >
                    {val?.name}{" "}
                    <CircleX
                      onClick={() => {
                        handleClearFilter(key);
                      }}
                    />
                  </Badge>
                ) : null
              )}
            </div>

            <Grid
              className="text-xs"
              data={requestsData?.data}
              {...dataState}
              pageable
              onPageChange={onPageChange}
              pageSize={pageSize}
              total={requestsData?.totalRecords || 0}
              skip={(currentPage - 1) * pageSize}
              take={pageSize}
              onDataStateChange={onDataStateChange}
              sortable
              filterable
              size="small"
            >
              <Column
                field="routeNo"
                title="Route No"
                width={160}
                cell={({ dataItem }) => (
                  <td>
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        setCurrentRoute(dataItem.routeNo);
                      }}
                      style={{ textDecoration: "underline", cursor: "pointer" }}
                    >
                      {dataItem.routeNo}
                    </div>
                  </td>
                )}
              />
              <Column field="region" title="Region" width={160} />
              <Column
                field="vanRegistrationNo"
                title="Van Registration No "
                width={200}
              />
              <Column
                field="vanCashLimit"
                title="Van Cash Limit "
                width={200}
              />

              <Column
                field="TeamLeader"
                title="Team Leader"
                width={160}
                cell={({ dataItem }) => (
                  <td>
                    {dataItem.teamLeaderName}-{dataItem.teamLeaderId}
                  </td>
                )}
              />
              <Column
                field="driverName"
                title="Driver"
                width={160}
                cell={({ dataItem }) => (
                  <td>
                    {dataItem.driverName}-{dataItem.driverId}
                  </td>
                )}
              />
              <Column field="status" title="Status" width={160} />
              <Column field="limitStatus" title="Limit Status" width={200} />
              <Column field="vanCash" title="Van Cash" width={160} />
              <Column field="percent" title="Percent" width={160} />
            </Grid>
          </CardDescription>
        </CardContent>
      </Card>
      <Dialog
        open={currentRoute !== null}
        onOpenChange={(val) => {
          if (!val) {
            setCurrentRoute(null);
          }
        }}
      >
        <DialogContent
          className="w-[80vw] max-w-[80vw]"
          onOpenAutoFocus={(e) => {
            e.preventDefault();
          }}
        >
          <DialogHeader>
            <DialogTitle>Request Details</DialogTitle>{" "}
          </DialogHeader>
          <RequestDetails
            routeNo={currentRoute}
            cashCenterId={filters?.cashCenterId?.id || user.CashCenterId}
            operationDate={formatDate(
              filters?.operationDate?.id || new Date(),
              "yyyy-MM-dd'T'00:00:00.000'Z'"
            )}
          />
        </DialogContent>
      </Dialog>
    </Layout>
  );
}
